const decorationLineTokens = ({ colors }) => ({
  colors: {
    default: colors.neutral['50'],
    negative: colors.white,
    primary: colors.brandPrimary['30'],
    dark: colors.neutral['100'],
    train: colors.trainProductColor,
    flight: colors.flightProductColor,
  },
  sizes: {
    disk: {
      small: 8,
      base: 12,
      big: 16,
    },
    circleDot: {
      outsideCircle: {
        small: 12,
        base: 16,
        big: 24,
      },
      centralCircle: {
        small: 6,
        base: 8,
        big: 12,
      },
    },
    icon: {
      small: 26,
      base: 28,
      big: 30,
    },
    height: '100%',
    topLineHeight: 'calc(100% + 8px)',
  },
  space: {
    top: 8,
    offset: 5,
  },
});

export default decorationLineTokens;
